import React from "react";
import { useNavigate } from "react-router-dom";
import { useSeo } from "../../hooks/useSeo";
// ייבוא תמונות
import benImage from "../../assets/img/ben.jpeg";
import drorImage from "../../assets/img/Dror.jpeg";
import roniImage from "../../assets/img/Roni.jpeg";
// import benImage from '../../assets/img/ben.jpeg';
// import drorImage from '../../assets/img/Dror.jpeg';
// import roniImage from '../../assets/img/Roni.jpeg';

interface ContactPerson {
  id: number;
  name: string;
  title: string;
  role: string;
  description: string;
  email?: string;
  phone?: string;
  mobile?: string;
  website?: string;
  image?: string;
  note?: string;
}

interface ContactCategory {
  id: string;
  title: string;
  icon: string;
  color: string;
  contacts: ContactPerson[];
}

const RecommendedContactsPage: React.FC = () => {
  useSeo({
    title: "אנשי קשר מומלצים ליבוא רכב — סוכני מכס, שילוח ומשלחים | CarTax",
    description:
      "ספקים מומלצים בתהליך יבוא רכב: סוכני מכס, חברות ספנות, משלחים מארה\"ב ומאירופה ויועצי יבוא — לצד מחשבון לחישוב העלויות.",
  });

  const categories: ContactCategory[] = [
    {
      id: "customs-agents",
      title: "סוכני מכס",
      icon: "📋",
      color: "blue",
      contacts: [
        {
          id: 1,
          name: "בן ברוק",
          title: "סוכן מכס ויועץ במיסוי יבוא רכב לישראל",
          role: 'מנהל – מסווג מחלקת יבוא רכב בחברת חיים נתנאל בע"מ',
          description:
            "משחרר כלי רכב מהמכס לכל סוגי היבואנים, כל סוגי כלי הרכב. מייעץ לחברות ואנשים פרטיים בדבר מיסוי רכב, קביעת סיווג פרטי מכס.",
          email: "benb@nathaniel.co.il",
          mobile: "054-4512136",
          image: benImage,
        },
      ],
    },
    {
      id: "transport-advisors",
      title: "יועצי יבוא בתחום התחבורה",
      icon: "🏛️",
      color: "green",
      contacts: [
        {
          id: 2,
          name: "דרור גנון",
          title: "יועץ בתחום התחבורה והייבוא",
          role: "",
          description: "מומחה בתהליכי יבוא לישראל.",
          email: "drorganon@gmail.com",
          mobile: "050-5308683",
          image: drorImage,
        },
      ],
    },
    {
      id: "shipping-israel",
      title: "חברות ספנות בישראל",
      icon: "🚢",
      color: "cyan",
      contacts: [
        {
          id: 3,
          name: "רוני נמר",
          title: "מנו ספנות",
          role: "מנהל קווי אוניות גלנוע.",
          description:
            'סוכן של חברת Neptune Lines. מנהל קווי שינוע רכבים מאירופה, ארה"ב והמזרח לישראל.',
          email: "roni.namer@mano.co.il",
          phone: "04-8606654",
          mobile: "054-4606685",
          image: roniImage,
        },
      ],
    },
    {
      id: "usa-forwarders",
      title: 'משלחים מארה"ב',
      icon: "🇺🇸",
      color: "red",
      contacts: [
        {
          id: 4,
          name: "EXPRESS CARGO USA",
          title: 'משלחים מארה"ב לישראל',
          role: "סוכני מכס אמריקאיים",
          description:
            'מבצעים תהליכי יצוא מארה"ב לישראל כולל הובלה ימית במכולות.',
          email: "Shirid@expresscargousa.com",
          note: '⚠️ אינם מבצעים הובלות פנימיות בתוך ארה"ב. על המוכר למסור להם את הרכב והם יבצעו את תהליכי היצוא וההובלה הימית.',
        },
        {
          id: 5,
          name: "TGAL",
          title: 'משלחים מארה"ב לישראל',
          role: "סוכני מכס אמריקאיים",
          description:
            'מבצעים תהליכי יצוא מארה"ב לישראל כולל הובלה ימית במכולות.',
          email: "SteveS@tgal.us",
          website: "https://www.tgal.us/",
        },
      ],
    },
    {
      id: "europe-forwarders",
      title: "משלחים מאירופה",
      icon: "🇪🇺",
      color: "purple",
      contacts: [
        {
          id: 6,
          name: "GEOTRANS",
          title: "משלחים מאירופה לישראל",
          role: "סוכני מכס גרמניים",
          description: "מבצעים תהליכי יצוא מאירופה לישראל.",
          email: "t.kontic@geotrans.de",
          website: "https://www.geotrans.eu/english/",
          note: '📧 הסוכן הגרמני מבקש פניות רק במייל עם הנתונים הבאים: מיקוד ושם העיר ממנה האיסוף, נמל יעד מועדף בישראל, תוצר/דגם/שנת ייצור של הרכב, סוג הנעה, האם חדש או משומש, עלות נטו של הרכב במט"ח.',
        },
      ],
    },
  ];

  const getColorClasses = (color: string) => {
    const colors: Record<
      string,
      { border: string; text: string; light: string }
    > = {
      blue: {
        border: "border-blue-300",
        text: "text-blue-700",
        light: "bg-blue-50",
      },
      green: {
        border: "border-green-300",
        text: "text-green-700",
        light: "bg-green-50",
      },
      cyan: {
        border: "border-teal-300",
        text: "text-teal-700",
        light: "bg-teal-50",
      },
      red: {
        border: "border-red-300",
        text: "text-red-700",
        light: "bg-red-50",
      },
      purple: {
        border: "border-purple-300",
        text: "text-purple-700",
        light: "bg-purple-50",
      },
    };
    return colors[color] || colors.blue;
  };

  const navigate = useNavigate();

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-8 px-4"
    >
      <div className="max-w-6xl mx-auto">
        {/* כפתור חזור */}
        <div className="mb-6 mt-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors"
            aria-label="חזור לעמוד הקודם"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            <span>חזור</span>
          </button>
        </div>

        {/* כותרת ראשית ממורכזת */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            📞 אנשי קשר מומלצים
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            מתעניינים ביבוא רכב בייבוא אישי או מסחרי ורוצים לקבל הסבר, ייעוץ,
            הכוונה מקצועית או הצעת מחיר?
            <br />
            מוזמנים ליצור קשר עם הגורמים המקצועיים המוצגים באתר CARTAX
          </p>
        </div>

        {/* קטגוריות */}
        {categories.map((category) => {
          const colorClasses = getColorClasses(category.color);
          return (
            <div key={category.id} className="mb-10">
              {/* כותרת קטגוריה */}
              <div
                className={`flex items-center gap-3 mb-6 ${colorClasses.text}`}
              >
                <div
                  className={`p-2 rounded-lg ${colorClasses.light} text-2xl`}
                >
                  {category.icon}
                </div>
                <h2 className="text-2xl font-bold">{category.title}</h2>
              </div>

              {/* כרטיסי אנשי קשר */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {category.contacts.map((contact) => (
                  <div
                    key={contact.id}
                    className={`bg-white rounded-2xl shadow-lg border-2 ${colorClasses.border} overflow-hidden hover:shadow-xl transition-shadow duration-300`}
                  >
                    <div className="p-6">
                      {/* חלק עליון - תמונה ופרטים */}
                      <div className="flex gap-4 mb-4">
                        {contact.image ? (
                          <img
                            src={contact.image}
                            alt={contact.name}
                            className="w-24 h-24 rounded-full object-cover border-4 border-gray-100 shadow-md"
                          />
                        ) : (
                          <div
                            className={`w-24 h-24 rounded-full ${colorClasses.light} flex items-center justify-center border-4 border-gray-100 shadow-md`}
                          >
                            <span className="text-3xl">🏢</span>
                          </div>
                        )}
                        <div className="flex-1">
                          <h3 className="text-xl font-bold text-gray-800 mb-1">
                            {contact.name}
                          </h3>
                          <p
                            className={`text-sm font-semibold ${colorClasses.text} mb-1`}
                          >
                            {contact.title}
                          </p>
                          <p className="text-sm text-gray-500">
                            {contact.role}
                          </p>
                        </div>
                      </div>

                      {/* תיאור */}
                      <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                        {contact.description}
                      </p>

                      {/* פרטי יצירת קשר */}
                      <div className="space-y-2">
                        {contact.email && (
                          <a
                            href={`mailto:${contact.email}`}
                            className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
                          >
                            <span>📧</span>
                            <span className="text-sm">{contact.email}</span>
                          </a>
                        )}
                        {contact.phone && (
                          <a
                            href={`tel:${contact.phone.replace(/-/g, "")}`}
                            className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
                          >
                            <span>📞</span>
                            <span className="text-sm">
                              טלפון: {contact.phone}
                            </span>
                          </a>
                        )}
                        {contact.mobile && (
                          <a
                            href={`tel:${contact.mobile.replace(/-/g, "")}`}
                            className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors"
                          >
                            <span>📱</span>
                            <span className="text-sm">
                              נייד: {contact.mobile}
                            </span>
                          </a>
                        )}
                        {contact.website && (
                          <a
                            href={contact.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-gray-600 hover:text-purple-600 transition-colors"
                          >
                            <span>🌐</span>
                            <span className="text-sm">אתר אינטרנט</span>
                          </a>
                        )}
                      </div>

                      {/* הערה מיוחדת */}
                      {contact.note && (
                        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                          <p className="text-sm text-amber-800">
                            {contact.note}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {/* הערה תחתונה */}
        <div className="mt-10 p-6 bg-white rounded-2xl shadow-lg border border-gray-200">
          <div className="flex items-start gap-3">
            <span className="text-2xl">ℹ️</span>
            <div>
              <h3 className="font-bold text-gray-800 mb-2">שימו לב</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                אנשי הקשר המופיעים בדף זה הם גורמים מקצועיים מומלצים בתחום יבוא
                הרכב. CARTAX אינה אחראית על השירותים הניתנים על ידם ומומלץ לבצע
                בדיקה עצמאית לפני התקשרות.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendedContactsPage;
